const cards = [
  {
    id: 1,
    title: '深度起底：某顶流明星背后的资本运作与公关团队全解析',
    excerpt: '当前最火爆的顶流明星，其背后的经纪公司、投资方、公关策略到底是如何运作的？本文为你揭开娱乐产业背后的商业逻辑。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20business%20concept%20with%20interlocking%20geometric%20shapes%2C%20warm%20golden%20and%20charcoal%20color%20palette%2C%20sophisticated%20modern%20design%2C%20no%20text%20or%20people%2C%20clean%20composition&width=800&height=500&seq=cards-bg-01&orientation=landscape',
    author: '深度编辑组',
    time: '2小时前',
    reads: '3.2万',
  },
  {
    id: 2,
    title: '从选秀冠军到全网争议：某流量歌手的人设崩塌全记录',
    excerpt: '曾经凭借选秀节目一举成名的他，如何在短短两年内从全民偶像变成争议焦点？完整复盘其职业生涯的关键转折点。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20dramatic%20spotlight%20from%20above%2C%20atmospheric%20fog%2C%20dark%20background%20with%20warm%20light%20beam%2C%20theatrical%20mood%2C%20no%20people%2C%20cinematic%20photography&width=800&height=500&seq=cards-bg-02&orientation=landscape',
    author: '特约评论员',
    time: '4小时前',
    reads: '2.8万',
  },
  {
    id: 3,
    title: '网红经济大洗牌：2024年下半年最值得关注的行业趋势',
    excerpt: '随着监管政策收紧和平台规则变化，网红经济正在经历前所未有的变革。谁将在这场洗牌中存活，谁又将黯然离场？',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20financial%20district%20skyline%20with%20reflective%20glass%20buildings%2C%20warm%20sunset%20light%2C%20clean%20architectural%20photography%2C%20conceptual%20business%20atmosphere%2C%20no%20signage&width=800&height=500&seq=cards-bg-03&orientation=landscape',
    author: '行业观察组',
    time: '6小时前',
    reads: '2.1万',
  },
  {
    id: 4,
    title: '明星代言翻车大数据：哪些品类最容易出事，哪些品牌最谨慎',
    excerpt: '通过整理近三年上百起明星代言翻车案例，我们发现了其中隐藏的规律。品牌方选择代言人的标准正在发生根本性变化。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20analytics%20concept%20with%20floating%20charts%20and%20graphs%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20infographic%20style%2C%20no%20text%20readable%2C%20clean%20minimalist%20design&width=800&height=500&seq=cards-bg-04&orientation=landscape',
    author: '数据新闻组',
    time: '8小时前',
    reads: '1.9万',
  },
  {
    id: 5,
    title: '娱乐圈"潜规则"大揭秘：从选角到宣发的完整产业链',
    excerpt: '一部影视作品从选角到上映，其中的利益博弈远超观众想象。本文为你揭示娱乐产业中那些不为人知的运作规则。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20film%20set%20with%20camera%20equipment%20silhouettes%2C%20warm%20production%20lighting%2C%20atmospheric%20smoke%2C%20no%20people%2C%20professional%20movie%20making%20environment&width=800&height=500&seq=cards-bg-05&orientation=landscape',
    author: '资深娱记',
    time: '10小时前',
    reads: '1.7万',
  },
  {
    id: 6,
    title: '粉丝经济2.0：从打榜到氪金，饭圈文化如何重塑娱乐产业',
    excerpt: '从微博超话到直播间刷礼物，饭圈文化正在以前所未有的方式影响整个娱乐产业的生态。这是一场关于流量与金钱的深度博弈。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20community%20concept%20with%20glowing%20interconnected%20nodes%2C%20warm%20pink%20and%20gold%20gradients%2C%20modern%20tech%20aesthetic%2C%20clean%20composition%2C%20no%20text%2C%20futuristic%20atmosphere&width=800&height=500&seq=cards-bg-06&orientation=landscape',
    author: '文化评论组',
    time: '12小时前',
    reads: '1.5万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
            <i className="ri-article-line"></i>
            深度解读
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            深度吃瓜
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            不止于爆料，我们为你提供有深度、有观点的娱乐产业分析
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <article key={card.id} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[8/5] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      {card.author}
                    </span>
                    <span>{card.time}</span>
                  </div>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.reads}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}